@if (kart?.turu === "KART") {
<paylas-ikart-kutusu [(kart)]="kart"
                     [parametreSetleri]="parametreSetleri"
                     [parametreSetiZorunlu]="parametreSetiZorunlu"
                     [taslakDevreDisi]="taslakDevreDisi"
                     (paylasimYapildi)="paylasimYapildi.emit($event)" />
} @else if (kart?.turu === "UYAR_DOKUM") {
<paylas-uyar-kutusu [(kart)]="kart"></paylas-uyar-kutusu>
} @else {
<div class="ui cards"
     style="min-height: 15em; margin: 0;">

    <div class="card p-3">
        <div class="content mb-0">
            <div class="flex justify-content-center flex-wrap">
                <img src="./simgeler/fikoyt_yazi.webp"
                     height="76"
                     class="py-beyaz-arka" />
            </div>
            <div class="text-center">Burada Yetkili olduğunuz kartların ekleme ve paylaşımını yapabilirsiniz</div>
        </div>

        <div class="flex justify-content-center flex-wrap mb-3 ">
            <button class="basic ui button text-color-secondary w-6rem  hoverable hover:zipla-5 active:zipla-5"
                    (click)="servisUyarProjeler.kart.turu='KART'">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <img alt="logo"
                         src="./simgeler/fikoyt_yazi.webp"
                         style="width:  5rem;border-radius: 3px;" />
                    <span class="fadein animation-duration-1000 text-sm mt-2">FikoYT Verisi</span>
                </div>
            </button>
            <button class="basic ui button text-color-secondary w-6rem  hoverable hover:zipla-5 active:zipla-5"
                    (click)="servisUyarProjeler.kart.turu='UYAR_DOKUM'">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <img alt="logo"
                         src="./app/uyar/uyarmodel.webp"
                         style="height: 2.5rem;border-radius: 3px;" />
                    <span class="fadein animation-duration-1000 text-sm mt-2">Uyar Model</span>
                </div>
            </button>
        </div>
    </div>
</div>
}